import { render, staticRenderFns } from "./RegistrationQuestions.vue?vue&type=template&id=8132f288"
import script from "./RegistrationQuestions.vue?vue&type=script&lang=ts"
export * from "./RegistrationQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports